import { Box, Paper, Stack } from "@mui/material";
import CircularWithPath from "components/@extended/progress/CircularWithPath";

export default function FormLoader() {
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Box sx={{ p: 5 }}>
        <Stack direction="row" justifyContent="center">
          <CircularWithPath />
        </Stack>
      </Box>
    </Paper>
  );
}
